import React from 'react'
import { toast } from 'react-toastify'
import { Button, DashboardLayout, Icon, InputGroup, WsnToast } from '../../../components'
import { addNotification } from '../../../store/notifications'
import { currencyFmt } from '../../../utils'
import axios from 'axios'

import './SendCoin.scss'
import { useSelector, useDispatch } from 'react-redux'
import clsx from 'clsx'

const SendCoin = ({ onBackClick, unit }) => {
   const RATE = 357.32

   const dispatch = useDispatch()
   const { privateKey } = useSelector(state => state.user)
   const { isDarkTheme } = useSelector(state => state.theme)

   const [recipient, setRecipient] = React.useState('')
   const [amount, setAmount] = React.useState(0)
   const [unitToSend, setUnitToSend] = React.useState(unit)
   const [transactionFlag, setTransactionFlag] = React.useState(false)

   const renderConversion = () => {
      if (unitToSend === unit) {
         return `~${currencyFmt(amount * RATE)} USD`
      } else {
         return `~${amount / RATE} ${unit}`
      }
   }

   const executeTransaction = () => {
      setTransactionFlag(true)
      axios
         .post(`${process.env.REACT_APP_API_URL}/api/swap/sendTransaction`, {
            privateKey,
            receiverAddress: recipient,
            amountInEther: amount,
         })
         .then(function (response) {
            const heading = 'Transaction receipt!'
            const description = `Sent ${amount} ${unitToSend} to ${recipient}`
      
            dispatch(addNotification({ heading, description }))
            // url is optional
            toast(
               <WsnToast
                  heading={heading}
                  message={description}
                  url={'https://bscscan.com/tx/' + response.data.data.hash}
               />
            )
            // setTxhash('https://bscscan.com/tx/' + response.data.data.hash)
         })
         .catch(function (error) {
            console.log(error)
         })
      setTransactionFlag(false)
   }

   return (
      <DashboardLayout
         withNav={false}
         className={clsx('SendCoin', isDarkTheme && 'SendCoin--dark')}
      >
         <header className="SendCoin__header">
            <Icon
               className="SendCoin__header-back"
               name="chevron-left"
               onClick={onBackClick}
            />
            Send {unit}
         </header>
         <InputGroup
            id="recipient"
            className="SendCoin__recipient"
            label="Recipient Address"
            placeholder="Add here"
            value={recipient}
            isDarkTheme={isDarkTheme}
            onChange={e => setRecipient(e.target.value)}
            right={<span className="SendCoin__recipient-paste">Paste</span>}
         />
         <InputGroup
            id="amount"
            className="SendCoin__amount"
            label={`Amount ${unitToSend}`}
            placeholder="Add here"
            value={amount}
            isDarkTheme={isDarkTheme}
            onChange={e => setAmount(e.target.value)}
            right={
               <span
                  onClick={() =>
                     setUnitToSend(unitToSend === unit ? 'USD' : unit)
                  }
                  className="SendCoin__amount-unit"
               >
                  {unitToSend}
               </span>
            }
         />
         <div className="SendCoin__conversion">{renderConversion()}</div>
         {
            transactionFlag?
            <Button
               className="SendCoin__cta"
               variant="solid"
               color="gray"
               isDarkTheme={isDarkTheme}
            >
               Send
            </Button>
            :
            <Button
               className="SendCoin__cta"
               variant="solid"
               color="primary"
               onClick={() => executeTransaction()}
               isDarkTheme={isDarkTheme}
            >
               Send
            </Button>
         }
      </DashboardLayout>
   )
}

export default SendCoin
